import React from 'react'
import { useTranslation } from 'react-i18next'
import { DayButtonProps } from '../types'

export const DayButton = (props: DayButtonProps) => {
  const { day, modifiers, getPrice, isShowIcon = true, ...buttonProps } = props
  const { t } = useTranslation()
  const price = getPrice(day.date)

  return (
    <button
      {...buttonProps}
      className={`
        flex flex-col gap-1 h-16 items-center mt-1
        ${isShowIcon ? 'justify-center' : 'justify-center'}
        ${modifiers.listed ? 'border border-gray-300' : ''}
        ${modifiers.available ? 'border-green' : ''}
        ${modifiers.startRange || modifiers.endRange ? 'bg-green' : ''}
        ${modifiers.startRange ? 'rounded-l' : modifiers.endRange ? 'rounded-r' : modifiers.inRange ? '' : 'rounded'}
        ${modifiers.inRange ? 'bg-green-100 w-full' : 'w-12'}
      `}
      disabled={!modifiers.available}
    >
      <div
        className={`relative
          ${modifiers.available && !modifiers.inRange ? 'underline font-bold' : ''}
          ${modifiers.startRange || modifiers.endRange ? 'text-white' : modifiers.available ? 'text-primary' : 'text-gray-200'}
        `}
      >
        {day.date.getDate()}
        {modifiers.holiday && (
          <span className="absolute text-red-500 font-size-12 font-normal" style={{ marginTop: '-4px' }}>
            *
          </span>
        )}
      </div>
      {isShowIcon && (
        <>
          {modifiers.listed && modifiers.available && (
            <div
              className={`
                w-3 h-3 rounded-full border-2 border-solid
                ${modifiers.startRange || modifiers.endRange ? 'border-white' : 'border-green'}
              `}
            />
          )}
          {modifiers.listed && !modifiers.available && (
            <svg fill="none" height="15" viewBox="0 0 16 15" width="16" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4.14 2.27L8 6.13L11.84 2.29C11.9248 2.19972 12.027 2.12749 12.1404 2.07766C12.2538 2.02783 12.3761 2.00141 12.5 2C12.7652 2 13.0196 2.10536 13.2071 2.29289C13.3946 2.48043 13.5 2.73478 13.5 3C13.5023 3.1226 13.4796 3.24439 13.4332 3.35788C13.3867 3.47138 13.3176 3.57419 13.23 3.66L9.34 7.5L13.23 11.39C13.3948 11.5512 13.4915 11.7696 13.5 12C13.5 12.2652 13.3946 12.5196 13.2071 12.7071C13.0196 12.8946 12.7652 13 12.5 13C12.3726 13.0053 12.2454 12.984 12.1266 12.9375C12.0078 12.8911 11.9 12.8204 11.81 12.73L8 8.87L4.15 12.72C4.06551 12.8073 3.96457 12.8769 3.853 12.925C3.74144 12.9731 3.62147 12.9986 3.5 13C3.23478 13 2.98043 12.8946 2.79289 12.7071C2.60536 12.5196 2.5 12.2652 2.5 12C2.49767 11.8774 2.52042 11.7556 2.56685 11.6421C2.61328 11.5286 2.68241 11.4258 2.77 11.34L6.66 7.5L2.77 3.61C2.60519 3.44876 2.50854 3.23041 2.5 3C2.5 2.73478 2.60536 2.48043 2.79289 2.29289C2.98043 2.10536 3.23478 2 3.5 2C3.74 2.003 3.97 2.1 4.14 2.27Z"
                fill="#D1D5DB"
              />
            </svg>
          )}
        </>
      )}

      {modifiers.listed && (
        <div
          className={`
            font-size-12
            ${modifiers.startRange || modifiers.endRange ? 'text-white' : modifiers.available ? 'text-green' : 'text-gray-200'}
          `}
        >
          {price}
          {price ? t('reservation_confirm.modal_booking.currency_man') : ''}
        </div>
      )}
    </button>
  )
}
